export default __webpack_public_path__ + "static/media/plus.c804d695.svg";